import axios, { AxiosResponse } from 'axios';
import { NotificationResponse, NotificationTypeId } from '../../models/notification.types';
import EnvWindow from '../../utils/env';

export const getNotifications = (
  pageSize: number,
  pageNumber: number,
): Promise<AxiosResponse<NotificationResponse>> => {
  return axios.get(
    `${EnvWindow.REACT_APP_NOTIFICATIONS__NOTIFICATION_API_URL}?pageSize=${pageSize}&pageNumber=${pageNumber}`,
  );
};

export const getAnyUnreadNotifications = (): Promise<AxiosResponse<boolean>> => {
  return axios.get(`${EnvWindow.REACT_APP_NOTIFICATIONS__NOTIFICATION_API_URL}/any`);
};

export const deleteNotification = (notificationId: string): Promise<AxiosResponse> => {
  return axios.delete(`${EnvWindow.REACT_APP_NOTIFICATIONS__NOTIFICATION_API_URL}/${notificationId}`);
};

export const updateNotificationAsRead = (notificationsId: string[]): Promise<AxiosResponse<number>> => {
  return axios.patch(`${EnvWindow.REACT_APP_NOTIFICATIONS__NOTIFICATION_API_URL}/read`, notificationsId);
};
